import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { RxFormGroup } from '@rxweb/reactive-form-validators';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss']
})
export class InputTextComponent implements OnInit {

  @Input() formParent: RxFormGroup;
  @Input() placeholder: string;
  @Input() frmControl: string;
  @Input() type: string;
  @Input() label: string;
  @Input() isIcon = false;
  @Input() icon: string;
  @Input() isTextArea: false;
  @Input() isOnlyInput: false;  
  @Input() setValue: number;
  @Input() isReadOnly = false;
  @Input() format: string;
  @Input() maxDigits: string;
  @Input() class_label: string;

  control: AbstractControl;
  selected = false;
  
  @Output() value = new EventEmitter<object>();
  @Output() blurEvent = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
    this.control = this.formParent.controls[this.frmControl];
    // if (this.control.keyName === 'quantity') {
    //   this.control.value = this.setValue;
    // }
  }

  focusOutInput(): void {
    this.blurEvent.emit();
  }

  focusInput(): void {
    this.selected = true;
  }


  keyupInput(event: any): void {
      this.value.emit(this.formParent.controls[this.frmControl].value);
  }

}
